import type { FaireProductEntity } from "../../entity_types/product";

export const p_efkkxmtub6: FaireProductEntity = {
  token: "p_efkkxmtub6",
  type: "product",
  name: "MARMONT",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/dab8b71183d3570bdd178d61e0141b0c9e2bc7504acf5778c57c3a1b50b04f8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3127e6143aaa1d0c3638408ad62112ae100bd7eb381536a77c6d6920056b36e3.jpeg",
    "https://cdn.faire.com/fastly/a6b670e3413e625b9aff143ebd62e0a6c9440cab0dbebd9482907a66b31f3c1c.jpeg",
    "https://cdn.faire.com/fastly/ff381b0b08db778c2a5f4eae8916f89b3fd0cebd069c4b016a5af6255d34c9ec.jpeg",
  ],
  priceDollars: 19,
  description:
    "Nestled in the Hollywood hills amidst lush gardens and hillside bungalows is the iconic Chateau Marmont. Recalling a lingering afternoon spent on the famed garden terrace with top notes of citrus, blackcurrant and rose opening to a seductively dark base of moss, musk, and a hint of leather. Creating a fragrance as compelling as its namesake hotel.\n\nwild rose, lily, white musk, moss, leather&nbsp;\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8.4 ounces (228g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T14:47:19.136Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
